class ModelMapperResult {
    readonly objects: string[];
    readonly materials: object[];
    readonly colors: object[];

    constructor(objects: string[], materials: object[], colors: object[]) {
        this.objects = objects;
        this.materials = materials;
        this.colors = colors;
    }
}

export interface IModel {
    cardDispenser: boolean,
    lightBox: boolean,
    printerShredder: boolean,
    thermoPrinter: boolean,
    keyboard: boolean,
    scanner: boolean,
    screenPrivacyFilter: boolean,
    material: string,
    colorValue?: string,
}

enum ObjectType {
    key_board = 'key_board',
    scanner = 'scanner',
    card_dispenser = 'card_dispenser',
    printer_thermo = 'printer_thermo',
    printer_shredder = 'printer_shredder',
    light = 'light',
    front_only = 'front_only',
    front_scanner_shredder = 'front_scanner_shredder',
    front_scanner = 'front_scanner',
    front_shredder = 'front_shredder',
}

const matNameMap = new Map<string, string>([
    ['orange', 'm_frontDummy'],
])

export const getObjects = () => {

    return Object.values(ObjectType);
}

export const mapModel = (model: IModel): ModelMapperResult => {
    const objects: string[] = [];
    if(model.keyboard) {
        objects.push(ObjectType.key_board)
    }
    if(model.scanner) {
        objects.push(ObjectType.scanner)
    }
    if(model.cardDispenser) {
        objects.push(ObjectType.card_dispenser)
    }
    if(model.thermoPrinter) {
        objects.push(ObjectType.printer_thermo)
    }
    if(model.printerShredder) {
        objects.push(ObjectType.printer_shredder)
    }
    if(model.lightBox) {
        objects.push(ObjectType.light)
    }
    if(model.scanner && model.printerShredder) {
        objects.push(ObjectType.front_scanner_shredder)
    }
    else if(model.scanner && !model.printerShredder) {
        objects.push(ObjectType.front_scanner)
    }
    else if(!model.scanner && model.printerShredder) {
        objects.push(ObjectType.front_shredder)
    }
    else {
        objects.push(ObjectType.front_only)
    }

    const aoMatName = model.keyboard ? 'front_key_ao' : 'front_ao';

    let materials:object[] = [];
    const matName: string|undefined = matNameMap.get(model.material);
    if(undefined === matName) {
        console.log(`ERROR: Could not map material name ${model.material}`);
    }
    else {
        materials = [{
            shadingGroupId: 'mat_board_rahmen',
            matName,
            aoMatName
        }, {
            shadingGroupId: 'mat_board_wanne',
            matName,
            aoMatName
        }, {
            shadingGroupId: 'mat_front',
            matName,
            aoMatName
        }, {
            shadingGroupId: 'mat_display',
            matName: model.screenPrivacyFilter ? 'm_spf' : 'm_display'
        }]
    }

    const colors = [{
        shadingGroupId: 'mat_board_rahmen',
        colorValue: model.colorValue,
    }, {
        shadingGroupId: 'mat_board_wanne',
        colorValue: model.colorValue,
    }, {
        shadingGroupId: 'mat_front',
        colorValue: model.colorValue,
    },];

    return new ModelMapperResult(objects, materials, colors);
}